import { render, staticRenderFns } from "./EditActivityConfigDialog.vue?vue&type=template&id=6d01254e&scoped=true"
import script from "./EditActivityConfigDialog.vue?vue&type=script&lang=js"
export * from "./EditActivityConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./EditActivityConfigDialog.vue?vue&type=style&index=0&id=6d01254e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d01254e",
  null
  
)

export default component.exports